export default class OportunidadeDetailsController {
  constructor($http, $q, $state, $scope, FileUploader, AuthenticationService, AuthorizationService, UIService, OportunidadeService, Oportunidade, OportunidadeAnexo, TipoAnexo) {
    this.$http = $http;
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.FileUploader = FileUploader;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.AuthorizationService = AuthorizationService;
    this.OportunidadeService = OportunidadeService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Oportunidade = Oportunidade;
    this.OportunidadeAnexo = OportunidadeAnexo;
    this.TipoAnexo = TipoAnexo;
    this.showEstadosPanel = false;

    this.loaded = false;

    this.anexos = [];
    this.anexosLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Oportunidade.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor']
      }
    }).$promise.then(res => {
      this.data = res;

      this.getAnexosForOportunidade();

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.oportunidade.list');
      this.UI.addToast('Erro ao carregar oportunidade. Verifique a ligação');
    });
  };

  // Edit titulo / descricao
  editTituloDescricao = () => {
    let options = {
      size: 'lg',
      template: require('./titulo.descricao.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Título e Descrição";
        $scope.oportunidade = angular.copy(this.data);


        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        this.Oportunidade.prototype$updateAttributes({id: this.data.id},
          {
            titulo: res.oportunidade.titulo,
            descricao: res.oportunidade.descricao,
            atualizadoPorId:  this.user.id,
            atualizadoa: moment().format()
          }
        ).$promise.then(() => {
          this.UI.addToast("Oportunidade atualizada com sucesso");
          this.loadData();
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar oportunidade. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  editDetalhes = () => {
    let options = {
      size: 'lg',
      template: require('./details.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.label = "Editar Oportunidade";
        $scope.oportunidade = angular.copy(this.data);
        $scope.simnao = this.simnao;
        $scope.removeDate = this.UI.removeDate;
        $scope.checkingSlug = false;
        $scope.dateOptions = {
          dataInicio: {format: 'DD/MM/YYYY'},
          dataFim: {format: 'DD/MM/YYYY'}
        };

        $scope.auxPublicada = {
          selected: $scope.oportunidade.publicada ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        $scope.auxDestaque = {
          selected: $scope.oportunidade.emDestaque ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          if (!$scope.oportunidade.dataInicio || !moment($scope.oportunidade.dataInicio).isValid()) {
            this.UI.addToast("Data de início inválida");
            return;
          }
          if (!this.OportunidadeService.isValidURL($scope.oportunidade.url)) {
            this.UI.addToast("URL inválido");
            return;
          }
          if (!this.OportunidadeService.isValidSlug($scope.oportunidade.slug)) {
            this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
            return;
          }
          // Check if slug exists
          $scope.checkingSlug = true;
          this.OportunidadeService.checkExistingSlug($scope.oportunidade.slug, this.data.id).then((exists) => {
            $scope.checkingSlug = false;
            if (exists) {
              this.UI.addToast("Este slug já existe para outra oportunidade");
            } else {
              $dialog.close($scope);
            }
          }).catch(err => {
            $scope.checkingSlug = false;
            this.UI.addToast("Erro de verificação de slug. Verifique a ligação");
            console.log(err);
          });
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        this.data.dataInicio = moment(res.oportunidade.dataInicio).isValid() ? moment(res.oportunidade.dataInicio).format() : null;
        this.data.dataFim = moment(res.oportunidade.dataFim).isValid() ? moment(res.oportunidade.dataFim).format() : null;
        this.data.url = res.oportunidade.url || null;
        this.data.urlText = res.oportunidade.urlText || this.data.url;
        this.data.slug = res.oportunidade.slug;
        this.data.resumo = res.oportunidade.resumo || null;

        this.data.publicada = res.auxPublicada.selected.value;
        this.data.emDestaque = res.auxDestaque.selected.value;

        this.data.atualizadoPorId = this.user.id;
        this.data.atualizadoa = moment().format();

        this.Oportunidade.upsert(this.data).$promise.then((res) => {
          this.UI.addToast("Dados atualizados com sucesso");
          this.loadData();
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar oportunidade. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  // Permissions
  canReadGeneral = () => this.AuthorizationService.canPerform('oportunidadeRead');
  canEditGeneral = () => this.AuthorizationService.canPerform('oportunidadeEdit');

  // Foto de Destaque

  addImagem = () => {
    let options = {
      size: 'lg',
      template: require('./images.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.images = {};
        $scope.label = "Editar imagem de oportunidade";
        $scope.newFileName = '';
        $scope.oldFileName = '';

        $scope.uuid = this.OportunidadeService.generateUUID();

        $scope.uploader = new this.FileUploader({
          url: '/api/Upload/oportunidades/upload',
          queueLimit: 1,
          formData: [
            {
              key: 'value'
            }
          ]
        });

        let filter = {
          name: 'verifyIMG',
          fn: function (item, options) {
            return item.type.indexOf("image/") !== -1;
          }
        };
        $scope.uploader.filters.push(filter);

        $scope.uploader.onAfterAddingFile = (item) => {
          let partes = item.file.name.split(".");
          $scope.newFileName = $scope.uuid + "." + partes[partes.length - 1];

          if ($scope.uploader.queue.length > 1)
            $scope.uploader.queue.splice(0, $scope.uploader.queue.splice.length - 1);
          $scope.oldFileName =  $scope.uploader.queue[0].file.name;
        };

        $scope.uploader.onWhenAddingFileFailed = (img) => {
          this.UI.addToast("Por favor, carregue uma imagem");
        };

        $scope.uploader.onErrorItem = (response, status, headers) => {
          this.UI.addToast("A imagem não foi carregada com sucesso");
        };

        $scope.uploader.onBeforeUploadItem = (item) => {
          item.file.name = $scope.newFileName;
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };

    let dialogCreate = this.UI.showDialog(options);

    dialogCreate.then((ok) => {
      if (ok.newFileName) {
        let wait = this.UI.showWaiting();
        this.Oportunidade.deleteImagem({id: this.data.id}).$promise.then(() => { // Delete previous
          this.Oportunidade.prototype$updateAttributes({id: this.data.id}, {imagem: ok.newFileName}).$promise.then(() => {
            if (ok.newFileName) {
              // File exists, upload it
              ok.uploader.uploadAll();
              this.loadData();
            } else {
              // No file, just update the list
              this.loadData();
            }
            wait.close();
            this.UI.addToast("Imagem adicionada com sucesso!");
          }).catch(err => {
            wait.close();
            this.UI.addToast("Erro a adicionar imagem.");
            console.log(err);
          });
        }).catch(error => {
          console.log(error);
          this.UI.addToast("Erro na substituição de imagem.");
        });
      }
    }).catch((error) => {
      if (error !== 'cancel' && error !== 'escape key press' && error !== 'backdrop click')
        console.log(error);
    });
  };

  confirmDeleteImagem = () => {
    let title = "Eliminar Imagem de Destaque de Oportunidade";
    let warning = "Tem a certeza que pretende remover esta imagem de destaque?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.deleteImagem();
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    });
  };

  deleteImagem = () => {
    this.Oportunidade.findById({id : this.data.id}).$promise.then((res) => {
      if (res) {
        if (res.imagem) {
          this.Oportunidade.deleteImagem({id: this.data.id}).$promise.then(() => {
            this.UI.addToast("Imagem removida com sucesso");
            this.loadData();
          }).catch(error => {
            console.log(error);
            this.UI.showAlert("Erro na remoção de imagem. Verifique se tem permissões e/ou verifique a ligação");
          });
        } else {
          this.UI.addToast("Oportunidade sem imagem definida");
          this.loadData();
        }
      } else {
        this.UI.addToast("Imagem não encontrado. Verifique a ligação");
        this.loadData();
      }
    }).catch((error) => {
      console.log(error);
    });
  };


  // Anexos

  getAnexosForOportunidade = () => {
    this.anexosLoading = true;
    this.OportunidadeAnexo.find({
      filter: {
        where: {
          oportunidadeId: this.data.id
        },
        include: 'tipoAnexo'
      }
    }).$promise.then(anexos => {

      anexos.forEach(doc => {
        this.$http.get('/api/upload/oportunidades/files/' + doc.nome).then(
          result => {
            if (result.data != null && !result.data.hasOwnProperty('error')) {
              doc.info = result.data;
            }
          },
          err => {
            console.log(err);
          }
        );
      });

      this.anexos = anexos;
      this.anexosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler anexos. Verifique a ligação");
    });
  };

  addAnexo = () => {
    let options = {
      size: 'lg',
      controller: 'OportunidadeFileUploaderController',
      controllerAs: 'm',
      template: require('./files.dialog.html'),
      resolve: {
        pID: () => {
          return this.data.id;
        },
        file: () => {
          return undefined;
        }
      }
    };
    let dialog = this.UI.showDialog(options);
    dialog.then(res => {
      if (res) {
        this.getAnexosForOportunidade();
        this.UI.addToast('Ficheiro carregado com sucesso');
      }
    });
  };


  // Ask confirmation to delete elemento
  confirmDeleteAnexo = (x) => {
    let title = "Remover Anexo";
    let warning = "Tem a certeza que pretende remover este anexo?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeAnexo(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeAnexo = (x) => {
    this.anexosLoading = true;
    // Find again anexo to delete
    this.OportunidadeAnexo.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((elementoToRemove) => {
      // Remove data
      this.OportunidadeAnexo.deleteAnexo({
        id: elementoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Anexo removido com sucesso");
        this.getAnexosForOportunidade();
      }).catch(error => {
        this.UI.addToast("Erro ao remover anexo. Verifique a ligação.");
        console.log(error);
        this.getAnexosForOportunidade();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar anexo. Verifique se ainda existe.");
      this.getAnexosForOportunidade();
    });
  };

  editInfoAnexo = (a) => {
    let wait = this.UI.showWaiting();
    this.TipoAnexo.find({
      filter: {
        where: {}
      }
    }).$promise.then((tiposAnexo) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./info.anexo.dialog.html'),
        controller: ['$scope', ($scope) => {
          $scope.label = "Editar Informação de Anexo";
          $scope.anexo = angular.copy(a);
          $scope.tiposAnexo = tiposAnexo;

          $scope.auxTipo = {
            selected: $scope.anexo.tipoAnexoId ? $scope.tiposAnexo.find(x => x.id === $scope.anexo.tipoAnexoId) : undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $scope.$close($scope);
          };

          $scope.cancel = () => $scope.$dismiss('cancel');
        }]
      };

      this.UI.showDialog(options).then(ok => {
        this.loaded = false;
        if (ok && ok.auxTipo && ok.auxTipo.selected) {
          this.OportunidadeAnexo.prototype$updateAttributes({id: ok.anexo.id}, {
            tipoAnexoId: ok.auxTipo.selected.id,
            descricao: ok.anexo.descricao
          }).$promise.then(() => {
            this.UI.addToast("Dados atualizados com sucesso");
            this.loadData();
          }).catch(error => {
            console.log(error);
            this.UI.showAlert("Erro ao atualizar oportunidade. Verifique a ligação");
            this.loaded = true;
          });
        }
      }).catch(() => {});
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Erro na procura de tipos de anexo. Verifique a ligação");
    });
  };
}

OportunidadeDetailsController.$inject = ['$http', '$q', '$state', '$scope', 'FileUploader', 'AuthenticationService', 'AuthorizationService', 'UIService', 'OportunidadeService', 'Oportunidade', 'OportunidadeAnexo', 'TipoAnexo'];
